module.exports = __webpack_public_path__ + "img/vip-img5.b9a147b3.png";